<template>
  <div>
    <li v-if="item.brickid === '4' && item.tourname" class="mobile-dropdown-item">
      <h4>Tour</h4>
      <p>{{ item.tourname }}</p>
    </li>
    <li v-if="item.brickid === '4' || item.brickid === '5'" class="mobile-dropdown-item">
      <h4>Operated by</h4>
      <p>{{ item.operator }}</p>
    </li>
    <li v-if="
      item.brickid === '1' || item.brickid === '2' || item.brickid === '3'
    " class="mobile-dropdown-item">
      <h4>For</h4>
      <p>{{ item.duration }}</p>
    </li>
    <li v-if="item.brickid === '1' || item.brickid === '2'" class="mobile-dropdown-item">
      <h4>With</h4>
      <p>{{ item.operator }}</p>
    </li>
    <li v-if="item.brickid === '1'" class="mobile-dropdown-item">
      <h4>Embark</h4>
      <p>{{ item.cityfrom }}</p>
    </li>
    <li v-if="item.brickid === '2' || item.jsontype === 'rail'" class="mobile-dropdown-item">
      <h4>Departing from</h4>
      <p>{{ item.cityfrom }}</p>
    </li>
    <li v-if="item.jsontype === 'rail'" class="mobile-dropdown-item">
      <h4>Departing at</h4>
      <p>{{ item.deptime }}</p>
    </li>
    <li v-if="item.brickid === '4' || item.brickid === '5'" class="mobile-dropdown-item">
      <h4></h4>
      <p>{{ item.cityfrom }}</p>
    </li>
    <li v-if="item.brickid === '1' && fil === 'M'" class="mobile-dropdown-item">
      <h4>Disembark</h4>
      <p>{{ item.cityto }} on {{ item.enddate }}</p>
    </li>
    <li v-if="item.brickid === '2' && fil === 'M'" class="mobile-dropdown-item">
      <h4>Tour ends in</h4>
      <p>{{ item.cityto }} on {{ item.enddate }}</p>
    </li>
    <li v-if="item.brickid === '2' && fil === 'M'" class="mobile-dropdown-item">
      <h4>Ends in</h4>
      <p>{{ item.cityto }}</p>
    </li>

    <li v-if="item.cityto" class="mobile-dropdown-item">
      <h4>Ends in</h4>
      <p>{{ item.cityto }}</p>
    </li>
    <li v-if="item.jsontype === 'rail'" class="mobile-dropdown-item">
      <h4>Arriving at</h4>
      <p>{{ item.arrtime }}</p>
    </li>
    <li v-if="item.jsontype === 'rail'" class="mobile-dropdown-item">
      <h4>{{ toTitleCase(item.operaction) }}</h4>
      <p>{{ item.operator }}</p>
    </li>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({ fil: "booking/getFil" }),
  },
  methods: {
    toTitleCase(str) {
      return str.replace(
        /\w\S*/g,
        txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
    }
  }
};
</script>

<style lang="scss">
@import "../styles.scss";
</style>
